import { useState } from 'react';
import { IconCircleOff, IconClockHour4, IconMaximize, IconUserOff } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { useToast } from '@hana/ui';
import './i18n';
import { DELEG_SALE, DELT_SALE } from './deleg';
import s from './home.module.css';
import d from './deleg.module.css';

// Mint-Home (1536) · N-04h: khối Tôi đang thay · uỷ quyền (vai sale) — theo code board deleg.*: thẻ người vắng, báo vắng, việc phát sinh trong kỳ thay, cap 4.
const CODE_CLS = (c: string): string | undefined => (['PRC', 'SLD', 'OPF', 'DCF', 'QAP'].includes(c) ? s.p : undefined);
const TONE = { tx: undefined, warn: d.dwarn, err: d.derr } as const;

export function Deleg({ empty }: { empty: boolean }) {
  const t = useT();
  const toast = useToast();
  const tip = (m: string) => toast({ msg: m });
  const [absent, setAbsent] = useState(false);
  const [done, setDone] = useState<Record<number, boolean>>({});
  const dels = empty ? [] : DELEG_SALE;
  const tasks = empty ? [] : DELT_SALE.slice(0, 4);
  return (
    <section className={s.my} aria-label={t('hn.dl.title0')}>
      <div className={s.myH}>
        <h2>{t('hn.dl.title')}</h2><span className={s.sum}>{t('hn.dl.active', { n: dels.filter((x) => x.on).length })}</span>
        <span className={s.grow} />
        {!absent && <button type="button" className={`${s.bt} ${d.abs}`} aria-haspopup="dialog" onClick={() => { setAbsent(true); tip(t('hn.dl.absentDone')); }}><IconUserOff size={16} stroke={1.8} aria-hidden="true" />{t('hn.dl.absent')}</button>}
        <button type="button" className={s.ib} aria-label={t('hn.dl.expandL')} title={t('home.expand')} onClick={() => tip(t('home.later'))}><IconMaximize size={15} stroke={2} aria-hidden="true" /></button>
      </div>
      {absent && (
        <div role="status" className={d.warn}>
          <span>{t('hn.dl.absentNow')}</span>
          <button type="button" className={s.bt} onClick={() => { setAbsent(false); tip(t('hn.dl.undone')); }}><IconCircleOff size={16} stroke={1.8} aria-hidden="true" />{t('hn.dl.cancel')}</button>
        </div>
      )}
      {!dels.length && <div className={s.none}>{t('hn.dl.none')}</div>}
      {dels.map((x) => (
        <div key={x.id} className={d.card}>
          <div className={d.top}>
            <span className={d.av}>{x.ab}</span>
            <div className={s.rb}><b>{t('hn.dl.for', { k: x.k })}</b><div className={d.src}>{x.src}</div></div>
            <span className={`${d.pill} ${x.on ? d.pOn : d.pOff}`}>{x.on ? t('hn.dl.on') : t('hn.dl.ready')}</span>
          </div>
          <div className={d.scope}>{x.scope} · {x.range} · {t('hn.dl.appr', { a: x.appr })}</div>
          <div className={d.cnt}><span>{t('hn.dl.period')} <b>{x.n}</b></span><span>{t('hn.overdue')} <b className={x.over ? d.derr : undefined}>{x.over}</b></span><span>{t('hn.doneL')} <b>{x.doneN}</b></span></div>
        </div>
      ))}
      {tasks.length > 0 && <div className={d.hd}>{t('hn.dl.born')}</div>}
      {tasks.map((x) => (
        <div key={x.id} className={`${d.row} ${done[x.id] ? d.fin : ''}`}>
          <input type="checkbox" aria-label={t('hn.doneT', { t: x.title })} checked={!!done[x.id]} onChange={() => { setDone((v) => ({ ...v, [x.id]: !v[x.id] })); tip(done[x.id] ? t('hn.reopen', { c: x.code }) : t('hn.dl.doneFor', { c: x.code, k: x.forK })); }} />
          <span className={`${s.code} ${CODE_CLS(x.code)}`} title={x.code}>{x.code}</span>
          <div className={s.rb}><div className={s.rt}>{x.title}</div><div className={d.sub}><a href="/ezy/jobs">{x.obj}</a> · {x.sub} · {t('hn.dl.sub', { k: x.forK })}</div></div>
          <span className={`${d.due} ${TONE[x.tone]}`} title={x.dueK} aria-label={x.dueK}><IconClockHour4 size={12} stroke={1.8} aria-hidden="true" />{x.dueK}</span>
        </div>
      ))}
    </section>
  );
}
